/* AELA (26 Oct 2026): product page trust badges become a slow moving strip on blush.
   Uses the badge images already set in the Trust Badges section, so changing a badge in the theme editor still works. */
(function () {
  function build() {
    document.querySelectorAll('.shopify-section--multi-column').forEach(function (sec) {
      if (sec.dataset.aelaTb) return;
      var imgs = sec.querySelectorAll('.multi-column__media img');
      if (!imgs.length) return;
      var srcs = Array.prototype.map.call(imgs, function (i) {
        var s = i.getAttribute('src') || '';
        return s.replace(/width=\d+/, 'width=300');
      });
      var one = srcs.map(function (s) { return '<img src="' + s + '" alt="" width="104" height="104">'; }).join('');
      var strip = document.createElement('div');
      strip.className = 'aela-tb';
      strip.setAttribute('aria-label', 'Pre-bonded clusters, 5 min application, 7 day wear, waterproof, latex free');
      strip.innerHTML = '<div class="aela-tb__track">' + one + one + one + one + '</div>';
      sec.dataset.aelaTb = '1';
      sec.classList.add('aela-tb-source');
      sec.after(strip);
    });
  }

  /* AELA (26 Oct 2026): every product comes in Brown too. Where a product's Colour option has no Brown
     yet (for example the kits), show a Brown swatch that can't be selected, labelled Coming soon.
     Display only: nothing is added to the product in Shopify, so the live store is unaffected. */
  function addBrown() {
    document.querySelectorAll('variant-picker .variant-picker__option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || !/colou?r/i.test(legend.textContent)) return;
      var values = fs.querySelector('.variant-picker__option-values');
      if (!values || values.querySelector('.aela-brown-soon')) return;
      if (/brown/i.test(values.textContent)) return;
      var wrap = document.createElement('span');
      wrap.className = 'aela-brown-soon';
      wrap.setAttribute('title', 'Brown, coming soon');
      wrap.innerHTML = '<span class="color-swatch aela-brown-soon__swatch" aria-hidden="true" style="--swatch-background: linear-gradient(to right, #5b4033, #5b4033)"></span>' +
        '<span class="aela-brown-soon__text">Brown <span class="aela-soon">Coming soon</span></span>';
      values.appendChild(wrap);
    });
  }

  function run() { build(); addBrown(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function () { clearTimeout(window.__aelaBrownT); window.__aelaBrownT = setTimeout(addBrown, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
